'use client';

import React, { useEffect } from 'react';
import { Section } from '@/types';
import { useVideoLoading } from '@/contexts/MediaContext';

interface VideoPreloaderProps {
  sections: Section[];
  children: React.ReactNode;
}

/**
 * Simplified VideoPreloader - only manages videosLoaded state
 * Actual preloading is handled by GlobalMediaPreloader
 * This component just signals when videos are ready to prevent loading screens
 */
export default function VideoPreloader({ sections, children }: VideoPreloaderProps) {
  const { setVideosLoaded } = useVideoLoading();

  // Mark videos as loaded after a short delay to allow natural loading
  // This prevents blocking the page while videos load
  useEffect(() => {
    // Short timeout to allow videos to start loading naturally
    const timeoutId = setTimeout(() => {
      setVideosLoaded(true);
    }, 300);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [sections, setVideosLoaded]);

  // Always render children immediately - videos load naturally
  return <>{children}</>;
}
